import { capitalize } from 'lodash'
import { ImportMessageDetails } from './types'

export const parseImportMessage = (message: string | undefined): ImportMessageDetails => {
  // Match both "Processed X rows" (file imports) and "Processed X <type> via API" (API imports)
  const totalRowsMatch = message ? RegExp(/Processed (\d+)/).exec(message) : 0
  const newRowsMatch = message ? RegExp(/(\d+) New/).exec(message) : 0
  const updatedRowsMatch = message ? RegExp(/(\d+) Updated/).exec(message) : 0
  const unchangedRowsMatch = message ? RegExp(/(\d+) Unchanged/).exec(message) : 0
  const errorRowsMatch = message ? RegExp(/(\d+) Not imported due to errors/).exec(message) : 0
  const filenameMatch = message ? RegExp(/INBOX\/(.+?)\.(json|csv)/).exec(message) : 0

  const totalRows = totalRowsMatch ? parseInt(totalRowsMatch[1], 10) : 0
  const newRows = newRowsMatch ? parseInt(newRowsMatch[1], 10) : 0
  const updatedRows = updatedRowsMatch ? parseInt(updatedRowsMatch[1], 10) : 0
  const unchangedRows = unchangedRowsMatch ? parseInt(unchangedRowsMatch[1], 10) : 0
  const errorRows = errorRowsMatch ? parseInt(errorRowsMatch[1], 10) : 0
  const filename = filenameMatch ? filenameMatch[1] : ''

  return {
    totalRows,
    newRows,
    updatedRows,
    unchangedRows,
    errorRows,
    filename,
  }
}

export const getEnumValues = (obj: object) => {
  return Object.entries(obj)
    .filter(
      ([key, _]) => !key.startsWith('_') && !key.startsWith('unknown'), // filter out junk enum values that come from the generated client
    )
    .map(([_, value]) => value)
}

export const convertEnumToDisplay = (enumString: string) => {
  return enumString
    .replaceAll('-', ' ')
    .replaceAll('_', ' ')
    .split(/\s+/g)
    .map(capitalize)
    .join(' ')
}
